import request from '../utils/request'


export function index(params) {
  	return request({
  	  url: '/regions',
  	  method: 'get',
        params
  	})
  }
 
  export function inventory(params) {
    return request({
      url: '/regions/inventory',
      method: 'get',
      params
    })
  }

export function show(id) {
    return request({
      url: `/regions/${id}`,
      method: 'get'
    })
  }

  export function store(data) {
    return request({
      url: '/regions',
      method: 'post',
      data
    })
  }

  export function update(data) {
    return request({
      url: `/regions/${data.id}`,
      method: 'put',
      data
    })
  }

  export function destroy(id) {
    return request({
      url: `/regions/${id}`,
      method: 'delete',
    })
  }
